// extracted by mini-css-extract-plugin
export var redoItem = "_ob-1";
export var redoTrigger = "_ob-0";